export default "__VITE_ASSET__BwnwxUFR__"